import { combineReducers } from 'redux';
import predictions from './predictions';
import { connectRouter } from 'connected-react-router'

const rootReducer = history => combineReducers({
  router: connectRouter(history),
  predictions
});

export default rootReducer;
